import { useState, useRef, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../../component/Header";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import api from "../../services/axios";
import { useSwal } from "../../services/SweetAlert";
import CustomDropdown from "../../component/CustomDropdown";
import EscalateTicketModal from "../../component/EscalateTicketModal";
import { useAuth } from "../../context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";
import FileUpload from "../../component/SvgIcons/FileUpload";
import FaqSidebar from "../../component/TicketSidebar/FaqSidebar";
import CreateTages from "../../component/CustomDropdown/CreateTages";
import IconClose from "../../component/SvgIcons/IconClose";
import utils, { emailPattern, phonePattern } from "../../utils/utils";
import CKEditorWrapper from "../../component/RichTextEditorFile";
import CreateIssues from "../../component/CustomDropdown/CreateIssues";
import IconError from "../../component/SvgIcons/IconError";
import { useSocket } from '../../context/SocketContext'
export default function CreateTickets() {
  const { authUserInfo } = useAuth();
  const { socketFlag, setSocketFlag } = useSocket();
  const { alert, confirm } = useSwal();
  const fileInputRef = useRef(null);
  const dropdownRefName = useRef();
  const dropdownRefCode = useRef();
  const [loading, setLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [authUser, setAuthUser] = useState();
  const [appType, setAppType] = useState([]);
  const [priority, setpriority] = useState([]);
  const [Customer_Type, setCustType] = useState([]);
  const [QueryType, setQueryType] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [allHashtags, setAllHashtags] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [filteredCustomerCode, setFilteredCustomerCode] = useState([]);
  const location = useLocation();

  const DEBOUNCE_DELAY = 300;

  useEffect(() => {
    const fetchAuth = async () => {
      let authInfo = await authUserInfo();
      setAuthUser(authInfo);
    }

    fetchAuth();
  }, [])

  const [formData, setFormData] = useState({
    Ticket_No: "",
    searchCode: "",
    Customer_Code: "",
    Contact_Person: "",
    User: authUser?.Code || "",
    Phone_no: "",
    Email_Id: "",
    Application_Name: "",
    Issue_Details: "",
    Status: "",
    Query: "",
    Remarks: "",
    search: "",
    Customer_Type: "",
    QueryType: "",
    tags: "",
    Priority_Id: 1,
    Designation: "",
    escalated_to: "",
    escalated_Status: "",
  });
  const filteredStatusData = statusData.filter(
    (status) => status.Name !== "ReOpened" && status.Name !== "Escalated"
  );
  const fetchCustomers = async (searchValue = "", column = '') => {
    try {
      const res = await api.post(
        `/paginated_customers?page=1&limit=10&search=${searchValue.trim()}`, { column: column }
      );
      if (res?.data?.data?.length && Array.isArray(res?.data?.data)) {
        if (column) {
          if (res?.data?.data[0]?.Code?.toLowerCase() == searchValue?.toLowerCase()) {
            handleCustomerSelect(res?.data?.data[0]);
          }

          else if (res?.data?.data?.length) {
            setFormData({
              Ticket_No: "",
              Customer_Code: '',
              Contact_Person: '',
              User: authUser?.Code || "",
              Phone_no: '',
              Email_Id: "",
              Application_Name: "",
              Issue_Details: "",
              Status: "",
              Query: "",
              searchCode: searchValue,
              Remarks: "",
              search: '',
              Customer_Type: '',
              QueryType: "",
              tags: "",
              Priority_Id: 1,
              Designation: '',
              escalated_to: "",
              escalated_Status: "",
            });
            setRowData(res.data.data);
            setFilteredCustomerCode(res.data.data)
          }
        }
        else {
          setRowData(res.data.data);
        }
      } else {
        console.warn("Unexpected data format:", res.data.data);
        setRowData([]);
        setFilteredCustomerCode([])
      }
    } catch (error) {
      console.error("Failed to fetch agents:", error);
    }
  };

  
  const useDebounce = (func, delay) => {
    const timeoutRef = useRef();
    
    const debouncedFn = useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        func(...args);
      }, delay);
    }, [func, delay]);
    
    return debouncedFn;
  };
  
  const debouncedFetch = useDebounce(fetchCustomers, DEBOUNCE_DELAY);


  const handleSearch = (e, column = "") => {
    let fieldName = 'search';
    const value = e.target.value;
    if (column) {
      fieldName = column ? "searchCode" : "search";
      setFormData((prev) => ({
        ...prev,
        searchCode: value,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        search: value,
      }));
    }

    setIsDropdownOpen(!!value);
    // fetchCustomers(value, column);
    debouncedFetch(value, column);
    validateField(fieldName, value);
  };

  const fetchCustomerInfo = () => {
    const params = new URLSearchParams(window.location.search);
    const callData = Object.fromEntries(params.entries());
    console.log("callData", callData)
    if (params.toString()) {
      setFormData({
        Ticket_No: "",
        Customer_Code: callData.code ?? '',
        Contact_Person: callData.caller_name ?? '',
        User: authUser?.Code || "",
        Phone_no: callData.caller_id_number ?? '',
        Email_Id: "",
        Application_Name: "",
        Issue_Details: "",
        Status: "",
        Query: "",
        searchCode: "",
        Remarks: "",
        search: callData.caller_name ?? '',
        Customer_Type: callData.caller_cust_type ?? '',
        QueryType: "",
        tags: "",
        Priority_Id: 1,
        Designation: callData.caller_designation ?? '',
        escalated_to: "",
        escalated_Status: "",
      });
    }
  };


  useEffect(() => {
    console.log(socketFlag);
    fetchCustomerInfo();
  }, [socketFlag])

  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        const response = await api.post("/Ticket_Statuses");
        setStatusData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching status data:", error);
      }
    };

    fetchStatusData();

    utils.saveRecentSearch("Create Ticket", "/create-ticket");

    fetchCustomers();

    const fetchAppTypes = async () => {
      try {
        const res = await api.post("/Application_Types");
        if (res.data.data && Array.isArray(res.data.data)) {
          const transformed = res.data.data.map((item) => ({
            value: item.Id,
            label: item.DisplayName,
          }));
          // setAppType(transformed);
          setAppType([
            { value: "", label: "Select Application Type", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch application types:", error);
      }
    };
    fetchAppTypes();

    const fetchpriority = async () => {
      try {
        const res = await api.post("/getpriority_list");

        if (res.data.data && Array.isArray(res.data.data)) {
          const transformed = res.data.data.map((item) => ({
            value: item.Id,
            label: item.DisplayName,
            color: item.ColorCode || "#000", // Default to black if no color is provided
          }));
          // setAppType(transformed);
          setpriority([
            { value: "", label: "Select Priority  Type", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch application types:", error);
      }
    };
    fetchpriority();

    const fetchCustTypes = async () => {
      try {
        const res = await api.post("/Customer_Types");
        if (res.data.data && Array.isArray(res.data.data)) {
          const transformed = res.data.data.map((item) => ({
            value: item.Name,
            label: item.DisplayName,
          }));
          setCustType([
            { value: "", label: "Select Customer Type", disabled: true },
            ...transformed,
          ]);
          // setCustType(transformed);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch application types:", error);
      }
    };
    fetchCustTypes();
    const fetchQueryType = async () => {
      try {
        const res = await api.post(
          "/getAllTemplates",
          {},
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        const dataArr = Array.isArray(res.data.data) ? res.data.data : [];

        if (dataArr.length > 0) {
          const transformed = dataArr.map((item) => ({
            value: item.TemplateID?.toString() ?? "",
            label: item.Query ?? "(no query text)",
            issueDetails: item.Issue ?? "",
            remarks: item.Remarks ?? "",
          }));

          setQueryType([
            { value: "", label: "Select Query Template", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("No templates found.");
        }
      } catch (err) {
        console.error("Failed to fetch templates:", err);
      }
    };

    fetchQueryType();

    const fetchTags = async () => {
      try {
        const res = await api.get("/getAllHashtags");
        const data = res.data.data || [];
        // Flatten and split comma-separated hashtag strings
        const tags = data
          .flatMap((item) => item.hashtag.split(",").map((tag) => tag.trim()))
          .filter(Boolean);

        // Unique and format for dropdown
        const uniqueTags = Array.from(new Set(tags)).map((tag) => ({
          value: tag,
          label: tag,
        }));
        console.log("Hashtags uniqueTags data:", uniqueTags);
        setAllHashtags(uniqueTags);
      } catch (err) {
        console.error("Failed to load hashtags:", err);
      }
    };

    fetchTags();

    const handleClickOutside = (event) => {
      if (
        (dropdownRefCode.current && dropdownRefCode.current.contains(event.target)) ||
        (dropdownRefName.current && dropdownRefName.current.contains(event.target))
      ) {
        return;
      }
      setIsDropdownOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);

  }, []);

  useEffect(() => {
    if (authUser?.Code) {
      setFormData((prev) => ({ ...prev, User: authUser.Code }));
    }
    console.log(formData)
  }, [authUser]);

  const getFieldError = (name, value) => {
    switch (name) {
      case "search":
        return !value?.trim() ? "Search is required." : "";
      case "searchCode":
        return !value?.trim() ? "Search Code is required." : "";
      case "Customer_Type":
        return !value ? "Customer type is required." : "";

      case "Contact_Person":
        return !value?.trim() ? "Contact person is required." : "";

      case "Application_Name":
        return !value ? "Application name is required." : "";

      case "Issue_Details":
        return !value?.trim() ? "Issue details are required." : "";

      case "Email_Id":
        if (!value?.trim()) return ""; // ✅ not required
        return emailPattern(value.trim()) ? "" : "Invalid email address.";

      case "Phone_no":
        if (!value?.trim()) return ""; // ✅ not required
        return phonePattern(value.trim()) ? "" : "Invalid phone number.";

      default:
        return "";
    }
  };
  const validateField = (name, value) => {
    const error = getFieldError(name, value);
    setFormErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const isFormValidForEscalation = (data) => {
    return (
      !!data.Customer_Code &&
      !!data.Contact_Person &&
      (!!data.Email_Id || !!data.Phone_no) &&
      // !!data.Status &&
      !!data.Issue_Details
    );
  };

  const filteredCustomers = rowData.filter((customer) => {
    const query = formData.search?.toLowerCase() || "";
    return (
      customer.Customer_Name?.toLowerCase().includes(query) ||
      customer.Contact_Email_Id?.toLowerCase().includes(query) ||
      customer.Contact_Mobile_No?.includes(query)
    );
  });

  const handleCustomerSelect = (customer) => {
    setFormData((prev) => ({
      ...prev,
      search: customer.Customer_Name || "",
      searchCode: customer.Code,
      Contact_Person: customer.Contact_Person || customer.Customer_Name,
      Phone_no: customer.Contact_Mobile_No || "",
      Email_Id: customer.Contact_Email_Id || "",
      Customer_Code: customer.Code || "",
      Customer_Type: customer.Customer_Type || "",
      Designation: customer.Designation || "",
    }));
    setFormErrors((prev) => ({ ...prev, search: "" }));
    setIsDropdownOpen(false);
    validateField(
      "Contact_Person",
      customer.Contact_Person || customer.Customer_Name
    );
    validateField("Customer_Type", customer.Customer_Type || "");
  };

  const handleChange = async (eOrName, maybeValue) => {
    if (typeof eOrName === "string") {
      setFormData((prev) => ({ ...prev, [eOrName]: maybeValue }));

      if (eOrName === "Query" && maybeValue) {
        try {
          const selectedTemplate = QueryType.find(
            (template) => template.value === maybeValue
          );
          if (selectedTemplate) {
            setFormData((prev) => ({
              ...prev,
              Issue_Details: selectedTemplate.issueDetails || "",
              Remarks: selectedTemplate.remarks || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching template details:", error);
        }
      }

      validateField(eOrName, maybeValue); // Correct: fieldName, value
    } else {
      const { name, value } = eOrName.target;
      setFormData((prev) => ({ ...prev, [name]: value }));

      if (name === "Query" && value) {
        try {
          const selectedTemplate = QueryType.find(
            (template) => template.value === value
          );
          if (selectedTemplate) {
            setFormData((prev) => ({
              ...prev,
              Issue_Details: selectedTemplate.issueDetails || "",
              Remarks: selectedTemplate.remarks || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching template details:", error);
        }
      }

      validateField(name, value); // Correct: fieldName, value
    }
  };

  const handleTagsChange = (selectedOptions) => {
    const selectedTags =
      selectedOptions?.map((tag) => tag.value).join(",") || "";
    setFormData((prev) => ({
      ...prev,
      tags: selectedTags,
    }));
  };

  const handleCreateTag = async (inputValue) => {
    const tagToInsert = inputValue.trim();
    if (!tagToInsert) return;

    const alreadyExists = allHashtags.some(
      (item) => item.value.toLowerCase() === tagToInsert.toLowerCase()
    );

    if (!alreadyExists) {
      try {
        await api.post("/insertHashtag", { hashtag: tagToInsert });

        // Add to dropdown list locally
        const newOption = { value: tagToInsert, label: tagToInsert };
        setAllHashtags((prev) => [...prev, newOption]);

        // Add to formData
        const currentTags = formData.tags ? formData.tags.split(",") : [];
        const updatedTags = [...currentTags, tagToInsert].map((t) => t.trim());

        setFormData((prev) => ({
          ...prev,
          tags: updatedTags.join(","),
        }));
      } catch (err) {
        console.error("Error inserting new hashtag:", err);
      }
    }
  };

  const handleEscalationSave = async (escalationData) => {
    const updatedFormData = {
      ...formData,
      ...escalationData,
    };
    setFormData(updatedFormData);

    if (!updatedFormData.Customer_Code) {
      await alert("warning", "Please select customer.");
      return;
    }

    if (!updatedFormData.Contact_Person) {
      await alert("warning", "Contact Person is required.");
      return;
    }
    if (!updatedFormData.Phone_no) {
      await alert("warning", "Phone Number is required.");
      return;
    }

    if (!updatedFormData.Status) {
      await alert("warning", "Status is required.");
      return;
    }

    if (!updatedFormData.Issue_Details) {
      await alert("warning", "Please provide issue details.");
      return;
    }
    if (updatedFormData.Status === "Escalated") {
      updatedFormData.escalated_Status = "InProgress";
    }
    await handleCreateTag(updatedFormData.tags);

    const payload = {
      Ticket_No: updatedFormData.Ticket_No,
      Customer_Code: updatedFormData.Customer_Code,
      Designation: updatedFormData.Designation,
      Contact_Person: updatedFormData.Contact_Person,
      User: updatedFormData.User,
      Phone_no: updatedFormData.Phone_no,
      Email_Id: updatedFormData.Email_Id,
      Application_Name: updatedFormData.Application_Name,
      Issue_Details: updatedFormData.Issue_Details,
      Status: updatedFormData.Status,
      Query: updatedFormData.Query,
      Remarks: updatedFormData.Remarks,
      tags: updatedFormData.tags,
      Priority_Id: updatedFormData.Priority_Id,
      Customer_Type: updatedFormData.Customer_Type,
      escalated_to: updatedFormData.escalated_to,
      escalated_Status: updatedFormData.escalated_Status,
      call_id: updatedFormData.call_id
    };

    try {
      setLoading(true);

      const formPayload = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formPayload.append(key, value);
        }
      });

      if (updatedFormData.picture) {
        formPayload.append("picture", updatedFormData.picture);
      }

      const res = await api.post("/create_ticket", formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const newTicketNo = res?.data?.Ticket_No;

      await alert(
        "success",
        `Ticket created successfully.\nTicket No: ${newTicketNo || "N/A"}`
      );

      setFormData({
        Ticket_No: "",
        Customer_Code: "",
        Contact_Person: "",
        User: authUser?.Code || "",
        Phone_no: "",
        Email_Id: "",
        Application_Name: "",
        Issue_Details: "",
        Status: "",
        search: "",
        searchCode: "",
        Customer_Type: "",
        Query: "",
        Remarks: "",
        tags: "",
        Priority_Id: 1,
        Designation: "",
        picture: null,
        escalated_to: "",
        escalated_Status: "",
        call_id: ""
      });

      setIsDropdownOpen(false);
    } catch (err) {
      setLoading(false);
      const message = err.response?.data?.message;
      await alert("warning", message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    let isValid = true;

    // Validate required fields except Email_Id and Phone_no
    [
      "search",
      "Customer_Type",
      "Contact_Person",
      "Application_Name",
      "Issue_Details",
    ].forEach((field) => {
      const error = getFieldError(field, formData[field]);
      if (error) {
        newErrors[field] = error;
        isValid = false;
      }
    });

    // Validate Email_Id and Phone_no: both optional but if entered must be valid
    if (formData.Email_Id?.trim()) {
      const emailError = getFieldError("Email_Id", formData.Email_Id);
      if (emailError) {
        newErrors.Email_Id = emailError;
        isValid = false;
      }
    }
    if (formData.Phone_no?.trim()) {
      const phoneError = getFieldError("Phone_no", formData.Phone_no);
      if (phoneError) {
        newErrors.Phone_no = phoneError;
        isValid = false;
      }
    }


    //     if (!formData.search) {
    //   await alert("warning", " Please Select Customer.");
    //   return;
    // }
    if (!formData.Status) {
      await alert("warning", "Status is required.");
      return;
    }

    // Validate Status if entered (optional)
    if (
      formData.Status !== undefined &&
      formData.Status !== null &&
      !formData.Status.trim()
    ) {
      newErrors.Status = "Status cannot be empty.";
      isValid = false;
    }

    setFormErrors(newErrors);

    if (!isValid) {
      setLoading(false);
      await alert("warning", "Please fill all required fields.");
      return;
    }

    if (!formData.Customer_Code) {
      // await alert("warning", " Please Select Customer.");
      // return;
      let newCustCode;
      if (formData.Customer_Type && formData.Contact_Person) {
        try {
          const result = await confirm(
            "Are you sure?",
            "Do you want to create this new customer?",
            "question"
          );
          console.log("Result:", result);
          if (!result) {
            return; // user clicked cancel
          }
          console.log("Confirmed:", result);
          // Create new customer
          const customerRes = await api.post("/create_customer", {
            Code: "Others-" + Date.now(), // Generate a unique code
            Customer_Name: formData.search,
            Serial_No: "",
            Location: "",
            City: "",
            State: "",
            Address: "",
            Designation: formData.Designation,
            Contact_Person: formData.Contact_Person,
            Contact_Mobile_No: formData.Phone_no,
            Contact_Email_Id: formData.Email_Id,
            Customer_Type: formData.Customer_Type,
            createdby: authUser?.Code || ""
          });

          // Set the new customer code in formData
          newCustCode = customerRes.data.Code; // or .Customer_Code depending on backend
          formData.Customer_Code = newCustCode;

          console.log("New customer created:", customerRes.data);
        } catch (err) {
          console.log("New customer already exists:", err.response.data.message);
          await alert(
            "warning",
            err.response?.data?.message || "Failed to create customer."
          );
          return;
        }
      } else {
        await alert(
          "warning",
          "Please select an existing customer or enter details to create a new one."
        );
        return;
      }

    }


    await handleCreateTag(formData.tags);

    const payload = {
      Ticket_No: formData.Ticket_No,
      Customer_Code: formData.Customer_Code,
      Contact_Person: formData.Contact_Person,
      User: formData.User,
      Phone_no: formData.Phone_no,
      Email_Id: formData.Email_Id,
      Application_Name: formData.Application_Name,
      Issue_Details: formData.Issue_Details,
      Status: formData.Status,
      Designation: formData.Designation,
      Query: formData.Query,
      Remarks: formData.Remarks,
      tags: formData.tags,
      Priority_Id: formData.Priority_Id,
      Customer_Type: formData.Customer_Type,
      escalated_to: formData.escalated_to,
      escalated_Status: formData.escalated_Status,
      call_id: formData.call_id
    };

    try {
      setLoading(true);

      const formPayload = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formPayload.append(key, value);
        }
      });

      if (formData.picture) {
        formPayload.append("picture", formData.picture);
      }
      console.log("res", formPayload);
      const res = await api.post("/create_ticket", formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });


      const newTicketNo = res?.data?.Ticket_No;

      await alert(
        "success",
        `Ticket created successfully.\nTicket No: ${newTicketNo || "N/A"}`
      );

      setFormData({
        Ticket_No: "",
        Customer_Code: "",
        Contact_Person: "",
        User: authUser?.Code || "",
        Phone_no: "",
        Email_Id: "",
        Application_Name: "",
        Issue_Details: "",
        Status: "",
        search: "",
        searchCode: "",
        Customer_Type: "",
        Query: "",
        Remarks: "",
        tags: "",
        Priority_Id: 1,
        Designation: "",
        picture: null,
        escalated_to: "",
        escalated_Status: "",
        call_id: ""
      });

      setIsDropdownOpen(false);
    } catch (err) {
      setLoading(false);
      const message = err.response?.data?.message;
      await alert("warning", message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && /\.(jpg|jpeg|png|webp)$/i.test(file.name)) {
      setSelectedFile(file);
    } else {
      alert("Please select a valid image file (jpg, jpeg, png, webp).");
      e.target.value = "";
      setSelectedFile(null);
    }
  };

  return (
    <div className="dashboard">
      <Header
        setShowSidebar={setShowSidebar}
        title
        subtitle="Create Ticket"
        backbtn="/tickets-list"
        searchbar
      />
      {/* <div
        className={`center-content ${
          showSidebar ? "custom-container mr-0" : "mr-hide"
        }`}
      > */}
      <motion.div
        className={`center-content custom-container ${!showSidebar ? "hide-sidebar" : ""}`}
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >

        {loading ? (
          <AnimatePresence mode="wait">
            <motion.div
              className="pagegap d-flex flex-column"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.4 }}
            >
              {/* Your loading UI here */}
              <div className="text-center py-4">
                <div
                  className="spinner-border text-primary"
                  role="status"
                ></div>
                <div>Loading Create Ticket Form...</div>
              </div>
            </motion.div>
          </AnimatePresence>
        ) : (
          <div className="container">
            <div className="pagegap">
              <h2 className="create-titles mb-0 d-flex align-items-center">
                <DiamondsFour /> <span>Create Tickets</span>
              </h2>

              <AnimatePresence mode="wait">
                <motion.form
                  key={formData.Ticket_No || "create-ticket"} // unique key to trigger animation if needed
                  className="createticket myform d-flex flex-column justify-content-between"
                  style={{ minHeight: "auto" }}
                  onSubmit={handleSubmit}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="form-savebtns newformbutton d-flex flex-wrap flex-xxl-row align-items-center">
                    <div className="status-buttons">
                      {/* <EscalateTicketModal /> */}
                      <EscalateTicketModal onSave={handleEscalationSave} disabled={!isFormValidForEscalation(formData)} />
                      {filteredStatusData?.map((status) => (
                        <button
                          key={status.Id}
                          type="button"
                          className={`btn statusbtnform ${formData.Status === status.Name ? "active" : ""
                            }`}
                          // style={{ backgroundColor: status.ColorCode }}
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              Status: status.Name,
                            }))
                          }
                        >
                          {status.DisplayName}
                        </button>
                      ))}
                    </div>

                    <div className="d-flex gap-2 xl-gap-4">
                      <Link to="/tickets-list" className="btn cancelbtn">
                        Close
                      </Link>
                      <button
                        type="submit"
                        className="btn btngradiant"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>

                  <div className="create-form d-flex flex-column">
                    <div className="form-row formresponsive">
                      <div
                        className={`form-group ${formErrors.searchCode ? "fieldrequire" : ""
                          }`}
                        ref={dropdownRefCode}
                      >
                        <label>
                          Search Customer Code{" "}
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Search Customer Code"
                          value={formData.searchCode}
                          onChange={e => handleSearch(e, "Code")}
                        />
                        {formData.searchCode && filteredCustomerCode?.length > 0 && (
                          <ul
                            className={`menulist ${isDropdownOpen ? "open" : ""
                              }`}
                          >
                            {filteredCustomerCode?.map((customer, index) => (
                              <li
                                key={index}
                                onClick={() => handleCustomerSelect(customer)}
                              >
                                <p>{customer.Customer_Name}</p>
                                <span>{customer.Code}</span>
                              </li>
                            ))}
                          </ul>
                        )}
                        <small className="hide">
                          <IconError />
                        </small>
                      </div>
                      <div
                        className={`form-group ${formErrors.search ? "fieldrequire" : ""
                          }`}
                        ref={dropdownRefName}
                      >
                        <label>
                          Search Customer{" "}
                          <span className="required-asterisk">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Search Name, Email, Mobile No."
                          value={formData.search}
                          onChange={handleSearch}
                        />
                        {formData.search && filteredCustomers.length > 0 && (
                          <ul
                            className={`menulist ${isDropdownOpen ? "open" : ""
                              }`}
                          >
                            {filteredCustomers.map((customer, index) => (
                              <li
                                key={index}
                                onClick={() => handleCustomerSelect(customer)}
                              >
                                <p>{customer.Customer_Name}</p>
                                <span>{customer.Contact_Mobile_No}</span>
                              </li>
                            ))}
                          </ul>
                        )}
                        <small className="hide">
                          <IconError />
                        </small>
                      </div>
                      <div
                        className={`form-group ${formErrors.Customer_Type ? "fieldrequire" : ""
                          }`}
                      >
                        <label>
                          Customer Type{" "}
                          <span className="required-asterisk">*</span>
                        </label>
                        <CustomDropdown
                          name="custType"
                          options={Customer_Type}
                          value={formData.Customer_Type}
                          onChange={(value) =>
                            handleChange("Customer_Type", value)
                          }
                          placeholder="Select Customer Type"
                        />
                        <small style={{ right: "40px" }} className="hide">
                          <IconError />
                        </small>
                      </div>

                      {["gulfemployee" , ""].includes(formData.Customer_Type.toLowerCase()) && (
                        <div className="form-group">
                          <label>Designation</label>
                          <input
                            type="text"
                            name="Designation"
                            className="form-control"
                            placeholder="Enter Designation"
                            value={formData.Designation}
                            onChange={handleChange}
                          />
                        </div>
                      )}

                      {["dss", "retailer", "others"].includes(formData.Customer_Type.toLowerCase()) && (
                        <div className="form-group">
                          <label>Distributor</label>
                          <input
                            type="text"
                            name="Designation"
                            className="form-control"
                            placeholder="Enter Distributor "
                            value={formData.Designation}
                            onChange={handleChange}
                          />
                        </div>
                      )}
                      <div
                        className={`form-group ${formErrors.Contact_Person ? "fieldrequire" : ""
                          }`}
                      >
                        <label>
                          Contact Person
                          <span className="required-asterisk">*</span>
                        </label>
                        <input
                          type="text"
                          name="Contact_Person"
                          className="form-control"
                          placeholder="Enter Name"
                          value={formData.Contact_Person}
                          onChange={handleChange}
                        />
                        <small className="hide">
                          <IconError />
                        </small>
                      </div>
                      <div
                        className={`form-group ${formErrors.Email_Id ? "fieldrequire" : ""
                          }`}
                      >
                        <label>Email</label>
                        <input
                          type="email"
                          name="Email_Id"
                          className="form-control"
                          placeholder="Enter email address"
                          value={formData.Email_Id}
                          onChange={handleChange}
                        />
                        <small className="hide">
                          <IconError />
                        </small>
                      </div>

                      <div
                        className={`form-group ${formErrors.Phone_no ? "fieldrequire" : ""
                          }`}
                      >
                        <label>Phone Number</label>
                        <input
                          type="text"
                          name="Phone_no"
                          className="form-control"
                          placeholder="Enter Phone Number"
                          value={formData.Phone_no}
                          onChange={handleChange}
                          inputMode="numeric"
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                              " ",
                            ];
                            const allowedChars = /^[\d+\-\s]$/;
                            if (
                              (e.ctrlKey || e.metaKey) &&
                              e.key.toLowerCase() === "a"
                            ) {
                              return;
                            }
                            if (
                              !allowedChars.test(e.key) &&
                              !allowedKeys.includes(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <small className="hide">
                          <IconError />
                        </small>
                      </div>

                      <div
                        className={`form-group ${formErrors.Application_Name ? "fieldrequire" : ""
                          }`}
                      >
                        <label>
                          Select Application Name{" "}
                          <span className="required-asterisk">*</span>
                        </label>
                        <CustomDropdown
                          options={appType}
                          placeholder="Select Application Type"
                          name="Application_Name"
                          value={formData.Application_Name}
                          onChange={(val) =>
                            handleChange("Application_Name", val)
                          }
                        />
                        <small style={{ right: "40px" }} className="hide">
                          <IconError />
                        </small>
                      </div>

                      <div className="form-group">
                        <label>Priority</label>
                        <CustomDropdown
                          options={priority}
                          placeholder="Select Priority Type"
                          name="Priority_Id"
                          value={formData.Priority_Id}
                          onChange={(val) => handleChange("Priority_Id", val)}
                        />
                      </div>
                      <CreateTages
                        label="Tags"
                        placeholder="Type or select tags"
                        options={allHashtags}
                        value={
                          formData.tags
                            ? formData.tags.split(",").map((tag) => ({
                              value: tag.trim(),
                              label: tag.trim(),
                            }))
                            : []
                        }
                        onChangeValue={handleTagsChange}
                        onBlur={(selectedOptions) => {
                          const tagsString = selectedOptions
                            .map((t) => t.value)
                            .join(",");
                          handleCreateTag(tagsString);
                        }}
                      />

                      <div className="form-group">
                        <label>Query</label>
                        <CreateIssues
                          options={QueryType}
                          placeholder="Select Query Template"
                          name="Query"
                          value={formData.Query}
                          onChange={(val) => handleChange("Query", val)}
                        />
                      </div>
                    </div>
                    <div
                      className={`form-group texteditor d-block ${formErrors.Issue_Details ? "fieldrequire" : ""
                        }`}
                    >
                      <label>
                        Issue <span className="required-asterisk">*</span>
                      </label>
                      <CKEditorWrapper
                        value={formData.Issue_Details}
                        onChange={(html) => handleChange("Issue_Details", html)}
                      />
                      <small className="hide">
                        <IconError />
                      </small>
                    </div>

                    <div className="form-group texteditor d-block">
                      <label>Remarks</label>
                      {/* <input
                          type="text"
                          name="Remarks"
                          className="form-control"
                          placeholder="Enter Remarks"
                          value={formData.Remarks}
                          onChange={handleChange}
                        /> */}
                      <CKEditorWrapper
                        value={formData.Remarks}
                        onChange={(html) => handleChange("Remarks", html)}
                      />
                    </div>
                    <div className="custom-file position-relative text-center d-flex gap-3 flex-row align-items-center">
                      <div
                        className={`pictureupload ${selectedFile ? "uploaded" : ""
                          }`}
                      >
                        <input
                          type="file"
                          name="picture"
                          accept=".jpg, .jpeg, .png, .webp"
                          className="custom-file-input position-absolute visually-hidden z-index-1"
                          id="inputGroupFile01"
                          onChange={handleFileChange}
                          ref={fileInputRef}
                        />
                        <label
                          className="custom-file-label d-flex align-items-center justify-content-center"
                          htmlFor="inputGroupFile01"
                        >
                          <FileUpload /> Upload Picture
                        </label>
                      </div>

                      <AnimatePresence>
                        {selectedFile && (
                          <motion.div
                            className="selected-file d-flex align-items-center justify-content-center gap-2"
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                          >
                            <p className="mb-0">
                              {selectedFile.name.length > 25
                                ? `${selectedFile.name.slice(0, 25)}...`
                                : selectedFile.name}
                            </p>
                            <button
                              type="button"
                              className="btn p-0"
                              onClick={() => {
                                setSelectedFile(null);
                                fileInputRef.current.value = "";
                              }}
                            >
                              <IconClose />
                            </button>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </div>
                </motion.form>
              </AnimatePresence>
              {/* </form> */}
            </div>
            <div className="customer-rightside">
              <AnimatePresence>
                <div
                  key="faqSidebar"
                  className="faqsidebar"
                  initial={{ x: 300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: 300, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <FaqSidebar customerCode={formData.Customer_Code} />
                </div>
              </AnimatePresence>
            </div>
          </div>
        )}
      </motion.div>
    </div>
  );
}
